import React from 'react'
import { Styling } from './styled.js'
import parse from 'html-react-parser'

export default function TextBlock({text, width}) {
    return (
        <Styling>
            <div className="textBlock" data-width={width}>
                {parse(text)}
            </div>
        </Styling>
    )
}
